export default __webpack_public_path__ + "static/topo-3a821520e2cad6d849427550bd8621b0.webp";